
const md5 = require('md5');
import { Toast } from 'vant';
import { Dialog } from 'vant';
import axios from 'axios';
import router from '../../router';
axios.defaults.baseURL = BzConfig.APIUrl;
import { showLoading, cancelLoading } from "js/loadingIndex2";
export const BzAjax = {
    get: function (url, data = {}, type = 'get') {
        return new Promise((resolve, reject) => {
            if (url.indexOf("?") > 0) {
                url = url + "&token=" + BzAjax.getkey();
            } else {
                url = url + "?token=" + BzAjax.getkey();
            }
            let option = {
                url: url,
                method: type,
                validateStatus(status) {
                    return (status >= 200 && status < 300) || status === 400;
                }
            };
            if (type.toLowerCase() === 'get') {
                option.params = data;
            } else {
                option.data = data;
            }
            showLoading({
                title: "",
            });
            axios(option).then((res) => {
                cancelLoading();
                if (res.status === 200) {
                    if (res.data.Status === 401) {
                        router.replace('login');
                    }
                    resolve(res.data);
                } else {
                    console.error(res.data.msg || '参数错误');
                    reject(res.data);
                }
            }).catch(function (err) {
                cancelLoading();
                console.error('网络异常: ' + err);
                reject({ msg: '网络异常' });

            });
        });
    },
    post: function (url, data = {}, type = 'post') {
        return new Promise((resolve, reject) => {

            if (url.indexOf("?") > 0) {
                url = url + "&token=" + BzAjax.getkey();
            } else {
                url = url + "?token=" + BzAjax.getkey();
            }
            let option = {
                url: url,
                method: type,
                validateStatus(status) {
                    return (status >= 200 && status < 300) || status === 400;
                }
            };
            if (type.toLowerCase() === 'get') {
                option.params = data;
            } else {
                option.data = data;
            }
            showLoading({
                title: "",
            });
            axios(option).then((res) => {
                cancelLoading();
                if (res.status === 200) {
                    if (res.data.Status === 401) {
                        router.replace('login');
                    } else if (res.data.Status == 0) {
                        resolve(res.data.Data);
                    } else {
                        BzMsg.ShowErr(res.data.ErrorMessage)
                    }
                } else {
                    console.error(res.data.msg || '参数错误');
                    reject(res.data);
                }
            }).catch(function (err) {
                cancelLoading();
                reject({ msg: '网络异常' });

            });
        });
    },
    postos: function (url, data = {}, type = 'post') {
        return new Promise((resolve, reject) => {
            if (url.indexOf("?") > 0) {
                url = url + "&token=" + BzAjax.getkey();
            } else {
                url = url + "?token=" + BzAjax.getkey();
            }
            let option = {
                url: url,
                method: type,
                validateStatus(status) {
                    return (status >= 200 && status < 300) || status === 400;
                }
            };
            if (type.toLowerCase() === 'get') {
                option.params = data;
            } else {
                option.data = data;
            }
            showLoading({
                title: "",
            });
            axios(option).then((res) => {
                cancelLoading();
                if (res.status === 200) {
                    if (res.data.Status === 401) {
                        router.replace('login');
                    }
                    if (res.data.Status == 0) {
                        resolve(res.data.Data);
                    } else {
                        BzMsg.ShowErr(res.data.ErrorMessage)

                    }
                    resolve(res.data);
                } else {
                    console.error(res.data.msg || '参数错误');
                    reject(res.data);
                }
            }).catch(function (err) {
                cancelLoading();
                reject({ msg: '网络异常' });

            });
        });
    },
    getkey: function () {
        let apploginid = "", key = "";
        var user = BzUser.get()
        apploginid = user.sumirryname;
        key = user.sumirrykey;
        const g = BzAjax.nokey();
        let sendkey = g + key;
        sendkey = md5(sendkey).toLowerCase();
        sendkey = sendkey.substring(8, 24);
        return g + sendkey + apploginid;
    },
    nokey: function () {
        function S4() {
            return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
        }
        return (S4() + S4() + S4() + S4());
    }

};
export const BzMsg = {
    ShowMsg: function (msg, callback) {
        Dialog.alert({
            title: '提示',
            message: msg,
        }).then(() => {
            callback();
        });
    },
    ShowToast: function (msg) {
        Toast(msg);
        if (callback) {
            callback();
        }
    },
    ShowErr: function (msg, callback) {
        Toast(msg);
        if (callback) {
            callback();
        }
    },
    ShowAsk: function (msg, callback) {
        Dialog.confirm({
            title: '提示',
            message: msg,
        })
            .then(() => {
                callback()
            })
            .catch(() => {
                // on cancel
            });

    },
    InputBox: function (options, callback) {


    },
    Loading: function (n, t) {
        if (n == true) {
            t == undefined ? "正在为您拼命加载。。。" : t

        } else {

        }

    }
};
export const BzUser = {
    get: function () {
        var users = JSON.parse(localStorage.getItem("localuser"));
        if (users == null) {
            users = {};
            users.IsLogin = 0;

            users.ExpiryDate = BzDate.format(new Date(), "yyyy-MM-dd hh:mm:ss")
        }
        if (BzDate.addHours(users.ExpiryDate, 2).getTime() < new Date().getTime()) {
            localStorage.removeItem("localuser");
            users.IsLogin = 0;
        } else {
            users.ExpiryDate = new Date();
            BzUser.setuser(users);
        }
        return users;
    },
    setuser: function (users) {
        localStorage.setItem("localuser", JSON.stringify(users))
    },
    deleteuser: function () {
        localStorage.removeItem("localuser");
    }
};
export const BzStore = {
    get: function () {
        var localstore = JSON.parse(localStorage.getItem("localstore"));
        if (localstore == null) {
            localstore = {};
        }
        return localstore;
    },
    setstore: function (store) {
        var localstore = BzStore.get();
        for (var j in store) {
            localstore[j] = store[j];
        }
        localStorage.setItem("localstore", JSON.stringify(localstore))
    },
    deletestore: function () {
        localStorage.removeItem("localstore");
    }
};
export const BzDate = {
    format(formatdate, fmt) { //author: meizz
        var o = {
            "M+": formatdate.getMonth() + 1, //月份
            "d+": formatdate.getDate(), //日
            "h+": formatdate.getHours(), //小时
            "m+": formatdate.getMinutes(), //分
            "s+": formatdate.getSeconds(), //秒
            "q+": Math.floor((formatdate.getMonth() + 3) / 3), //季度
            "S": formatdate.getMilliseconds() //毫秒
        };
        if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (formatdate.getFullYear() + "").substr(4 - RegExp.$1.length));
        for (var k in o)
            if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));

        return fmt;
    },
    //获取两个时间之间的间隔
    getTimeDiff(dateBegin, dateEnd, timetype) {
        var dateBegin = new Date(dateBegin);
        var dateEnd = new Date(dateEnd);
        var dateDiff = dateEnd.getTime() - dateBegin.getTime();//时间差的毫秒数
        switch (timetype) {
            case 1:
                return Math.floor(dateDiff / (24 * 3600 * 1000));//计算出相差天数
            case 2:
                return Math.floor(dateDiff / (3600 * 1000));//计算出小时数
            case 3:
                return Math.floor(dateDiff / (60 * 1000));//计算相差分钟数
            case 4:
                return Math.round(dateDiff / 1000);//计算毫秒数
        }
    },
    //判断第一个是不是比第二个大
    checkDate: function (Date1, Date2) {
        var oDate1 = new Date(Date1);
        var oDate2 = new Date(Date2);
        if (oDate1.getTime() > oDate2.getTime()) {
            return true;
        } else {
            return false;
        }
    },
    addMonth: function (pdate, n) {   // n个月后
        var mydate = new Date(pdate);
        //当前月
        var m = mydate.getMonth() + 1;
        var y = mydate.getFullYear();
        var retdate = mydate.getTime();
        for (var i = 0; i < n + 1; i++) {
            retdate += BzDate.getMonthDay(y, m) * 86400000
            m++;
            if (m == 13) {
                y++;
                m = 1;
            }
        }

        return new Date(retdate);
    },
    getMonthDay: function (year, month) {
        if (month == 2) {
            if (year % 4 == 0 && year % 100 != 0)
                return 29;
            else
                return 28;
        }
        else if ((month <= 7 && month % 2 == 1) || (month > 7 && month % 2 == 0))
            return 31;
        else
            return 30;
    },
    addHours: function (date1, hours) {
        var mydate = new Date(date1);
        var time = mydate.getTime() + 1000 * 60 * 60 * hours;
        return new Date(time);
    }
};
export const BzJs = {
    parseQueryString() {
        var url = window.location.href;
        var json = {};
        var arr = url.substr(url.indexOf('?') + 1).split('&');
        arr.forEach(item => {
            var tmp = item.split('=');
            json[tmp[0]] = tmp[1];
        });
        return json;
    },
    getArrayIndex(list, obj) {
        for (let i = 0; i < list.length; i++) {
            let IsDifferent = false;
            for (let key in obj) {
                if (list[i][key] != obj[key]) {
                    IsDifferent = true;
                    break;
                }
            }
            if (IsDifferent == false) {
                return i;
            }
        }
        return -1;
    },
    getMax(list, name) {
        let maxnumber = 0;
        list.forEach(element => {
            if (element[name] > maxnumber)
                maxnumber = element[name];
        })
        return maxnumber;
    },
    splitNumber(arrlength, number) {
        number = number.toString();

        var newarr = [];
        if (number.length < arrlength) {
            for (var i = number.length; i < arrlength; i++) {
                newarr.push(0);
            }
        }
        for (var i = 0; i < number.length; i++) {
            newarr.push(number.substr(i, 1))
        }

        return newarr;
    },
    guid() {
        function S4() {
            return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
        }
        return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
    },
    copyObject: function (source) {
        var result = {};
        for (var key in source) {
            result[key] = source[key];
        }
        return result;
    },
    getTimestamp: function () {
        return (new Date()).valueOf();
    },
    getPicName: function (url) {
        var reg = /.*\/(.*)/;
        return url.replace(reg, "$1")
    },
    exportExcel(url) {
        // const loadingInstance = Loading.service({
        //     lock: true,
        //     text: '正在为您导出，请耐心等待。。。',
        //     spinner: 'el-icon-loading',
        //     background: 'rgba(0, 0, 0, 0.7)'
        // });
        let iframe = document.createElement("iframe");
        iframe.src = url;

        iframe.style.display = "none";
        if (iframe.attachEvent) {
            iframe.attachEvent("onload", d => {

                // loadingInstance.close();
            });
        } else {
            iframe.onload = function () {

                // loadingInstance.close();
            };
        }
        document.body.appendChild(iframe);
        // setTimeout(() => {
        //     loadingInstance.close();
        // }, 1000);
    },
    getTextTrees(list) {
        let Types = { id: 0, label: "全部" };
        let children = [];
        list.forEach(element => {
            children.push({ id: element.OpValue, label: element.OpName });
        });
        Types.children = children;
        return Types;
    },
    getTrees(list) {
        let treeTypes = [];
        let types = list.filter(item => item.ParentId == 0);
        types.forEach(element => {
            var newel = {
                id: element.OpValue,
                label: element.OpName,
                children: []
            };
            var childrens1 = list.filter(
                item => item.ParentId == element.OpValue
            );
            childrens1.forEach(element1 => {
                var newel1 = {
                    id: element1.OpValue,
                    label: element1.OpName,
                    children: []
                };
                var childrens2 = list.filter(
                    item => item.ParentId == element1.OpValue
                );
                childrens2.forEach(element2 => {
                    newel1.children.push({
                        id: element2.OpValue,
                        label: element2.OpName
                    });
                });
                newel.children.push(newel1);
            });
            treeTypes.push(newel);
        });
        return treeTypes;
    },
    getSuperTree(list, IdName, ParentName, TextName) {
        let treeTypes = [];
        let types = list.filter(item => item[ParentName] == 0);
        types.forEach(element => {

            treeTypes.push(BzJs.getTreeChildren(element[IdName], element[TextName], list,
                element[IdName], IdName, ParentName, TextName));
        })
        return treeTypes;
    },
    getTreeChildren(OpValue, OpName, list, Id, IdName, ParentName, TextName) {
        let newel = {
            id: OpValue,
            label: OpName,
        };
        let types = list.filter(item => item[ParentName] == Id);
        if (types.length > 0) {
            newel.children = [];
            types.forEach(element => {
                newel.children.push(BzJs.getTreeChildren(element[IdName], element[TextName], list,
                    element[IdName], IdName, ParentName, TextName))
            });
        }
        return newel;

    },
    getSuperCascader(list, IdName, ParentName, TextName) {
        let treeTypes = [];
        let types = list.filter(item => item[ParentName] == 0);
        types.forEach(element => {

            treeTypes.push(BzJs.getCascadeChildren(element[IdName], element[TextName], list,
                element[IdName], IdName, ParentName, TextName));
        })
        return treeTypes;
    }, getCascadeChildren(OpValue, OpName, list, Id, IdName, ParentName, TextName) {
        let newel = {
            value: OpValue,
            label: OpName,
        };
        let types = list.filter(item => item[ParentName] == Id);
        if (types.length > 0) {
            newel.children = [];
            types.forEach(element => {
                newel.children.push(BzJs.getCascadeChildren(element[IdName], element[TextName], list,
                    element[IdName], IdName, ParentName, TextName))
            });
        }
        return newel;

    },
};
export const ElementConfig = {
    SystemDateOptions: {
        shortcuts: [
            {
                text: "最近一周",
                onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit("pick", [start, end]);
                }
            },
            {
                text: "最近一个月",
                onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                    picker.$emit("pick", [start, end]);
                }
            },
            {
                text: "最近三个月",
                onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                    picker.$emit("pick", [start, end]);
                }
            }
        ]

    }
};
export const BzCheck = {
    required(name) {
        return [
            {
                required: true,
                message: name + "必须填写！",
                trigger: ["change", "blur"]
            }
        ];
    }
}



// WEBPACK FOOTER //
// ./src/modules/js/helper.js